import { getClientId } from "@smartsheet/lodestar-utils";
import React, { FC } from "react";
import { useCombinedThemeMode } from "../../../../util/theme/useCombinedThemeMode";
import { DatePickerTextInputPlaceholderInvisible } from "../styled/DatePickerTextInputPlaceholderInvisible";
import { DatePickerTextInputPlaceholderStyled } from "../styled/DatePickerTextInputPlaceholderStyled";
import { DatePickerTextInputPlaceholderVisible } from "../styled/DatePickerTextInputPlaceholderVisible";

export interface DatePickerTextInputPlaceholderProps {
    clientId: string | undefined;
    format: string;
    validationState: "error" | undefined;
    value: string;
}

export const DatePickerTextInputPlaceholder: FC<DatePickerTextInputPlaceholderProps> = ({
    clientId,
    format,
    validationState,
    value,
}) => {
    const themeMode = useCombinedThemeMode();

    return (
        <DatePickerTextInputPlaceholderStyled
            data-client-id={getClientId(clientId, "dp-input-placeholder")}
            themeMode={themeMode}
            validationState={validationState}
        >
            <DatePickerTextInputPlaceholderInvisible>{value}</DatePickerTextInputPlaceholderInvisible>
            <DatePickerTextInputPlaceholderVisible>
                {format.substring(value.length)}
            </DatePickerTextInputPlaceholderVisible>
        </DatePickerTextInputPlaceholderStyled>
    );
};
